// Helper: format label per giorno
export function formatDateLabel(dateStr) {
    const today = new Date();
    const date = new Date(
        parseInt(dateStr.slice(0, 4), 10),
        parseInt(dateStr.slice(4, 6), 10) - 1,
        parseInt(dateStr.slice(6, 8), 10)
    );
    const diff = Math.floor((today - date) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'Oggi';
    if (diff === 1) return 'Ieri';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
}

// Raggruppa liste per giorno e numeri contigui
export function groupCalls(items) {
    const sorted = [...items].sort((a, b) => new Date(a.data_ora) - new Date(b.data_ora));
    const byDate = sorted.reduce((acc, item) => {
        const day = item.data;
        acc[day] = acc[day] || [];
        acc[day].push(item);
        return acc;
    }, {});
    return Object.keys(byDate)
        .sort((a, b) => b.localeCompare(a))
        .map(day => {
            const dayItems = byDate[day];
            const groups = [];
            let current = null;
            dayItems.forEach(item => {
                if (!current || current.numero !== item.numero) {
                    if (current) groups.push(current);
                    current = prepareCallObject(item);
                } else {
                    if (!current.childrenCalls) {
                        current.childrenCalls = [];
                    }
                    current.childrenCalls.push({id: item.id});
                    current.count += 1;
                    current.read = current.read && item.read;
                }
            });
            if (current) groups.push(current);
            return { day, label: formatDateLabel(day), items: groups };
        });
}

export const prepareCallObject = (item) =>{
    let priorita = (item.chiamante_priorita ? 'yes' : 'no') + (item.chiamante_hanoteprerisposta ? '-with-note' : '');
    return{
        ...item,
        blocco: item.chiamante_blocco,
        priorita: priorita,
        day: formatDateLabel(item.data),
        lastCallTime: item.data_ora.split(' ')[1].replace(/:\d{2}$/, ''),
        chiamante_id: item.chiamante_id || item.chiamante?.model?.id,
        count: (item.count || 1), // Assicurati che count sia sempre definito
    }
}